import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { toast } from "react-toastify";
import { uplusState } from "../../../../Enum/state.Enum";
import { useApi } from "../../../../hooks/useApi";
import Flex from "../../../DefaultStyles/Flex";
import Loader from "../../../DefaultStyles/Loader";
import DropDown, { OptionType } from "../../../Filters/DropDown";
import { Input } from "../../../Input/Input";
import DefaultModalLayout from "../../../Modal/DefaultModalLayout";
import { ModalRow } from "../../Users/UserDetail/BlackListModal/BlackListModal";
import { DefaultModalCommonProps } from "../../Users/UserDetail/CommentModal/CommentModal";
import { ModalLabel } from "../../Users/UserDetail/CommentModal/TargetContainer";
import UplusMatchingStatusAskModal from "./UplusMatchingStatusChangeModal/UplusMatchingStatusAskModal";
import UplusMatchingStatusResultModal from "./UplusMatchingStatusChangeModal/UplusMatchingStatusResultModal";

interface UplusMatchingStatusChangeModalProps extends DefaultModalCommonProps {
  isSelect?: boolean;
  nowStatus?: number;
  selectedKey?: string[];
}

export default function UplusMatchingStatusChangeModal({
  closeEvent,
  confirmEvent,
  isSelect,
  nowStatus,
  selectedKey,
}: UplusMatchingStatusChangeModalProps) {
  console.log(selectedKey);

  const [statusDropdown, setStatusDropdown] = useState<OptionType>({
    value: nowStatus === 1 ? "2" : "",
    label: nowStatus === 1 ? "결합 대기" : "선택",
  });
  const [reasonDropdown, setReasonDropdown] = useState<OptionType>({
    value: "",
    label: "사유 선택",
  });
  const [reason, setReason] = useState("");
  const [askChangeAlert, setAskChangeAlert] = useState(false);
  const [selectChange, setSelectChange] = useState(false);
  const [allChange, setAllChange] = useState(false);
  const [resultModal, setResultModal] = useState(false);

  // 선택 상태 변경
  const { response, loading, error } = useApi({
    method: "post",
    url: selectChange ? `uplus` : undefined,
    data: {
      keyList: selectedKey?.filter((a) => a !== null) ?? [],
      state: Number(statusDropdown?.value) ?? 0,
      reason:
        reasonDropdown?.value !== "5" && reasonDropdown?.value !== ""
          ? reasonDropdown?.label
          : reason,
    },
  });

  // 전체 상태 변경
  const {
    response: allRes,
    loading: allLoading,
    error: allErr,
  } = useApi({
    method: "post",
    url: allChange ? `uplus/all` : undefined,
  });

  // 매칭중 개수 가져오기
  const {
    response: cntRes,
    loading: cntLoading,
    error: cntError,
  } = useApi({
    method: "get",
    url: !isSelect ? `uplus/cnt` : undefined,
  });

  // 상태 변경 실패 인원
  const failCnt =
    (allRes?.data?.totalcnt ?? response?.data?.totalcnt ?? 0) -
    (allRes?.data?.successcnt ?? response?.data?.successcnt ?? 0);

  const statusOption =
    nowStatus === 2
      ? [
          { value: "3", label: "결합 완료" },
          { value: "5", label: "결합 실패" },
        ]
      : nowStatus === 3
      ? [{ value: "4", label: "종료" }]
      : [];

  const reasonOption = [
    { value: "1", label: "타사 고객(유플러스 미개통)" },
    { value: "2", label: "결합 대상 요금제 미사용" },
    { value: "3", label: "결합 대상 연령이 아님" },
    { value: "4", label: "회선 정지 상태" },
    { value: "6", label: "중복 결합 불가" },
    { value: "5", label: "기타(직접 입력)" },
  ];

  useEffect(() => {
    if (response?.status === 201 || allRes?.status === 201) {
      if (response?.data?.successcnt > 0 || allRes?.data?.successcnt > 0) {
        setResultModal(true);
      } else {
        toast.error(
          `${isSelect ? "선택" : "전체"} 결합 상태 변경에 실패하였습니다.`
        );
      }
    }
  }, [response, allRes]);

  useEffect(() => {
    if (error?.data || allErr?.data || cntError?.data) {
      toast.error(
        cntError?.data ??
          allErr?.data ??
          error?.data ??
          `${isSelect ? "선택" : "전체"} 결합 상태 변경에 실패하였습니다.`
      );
    }
  }, [error, allErr, cntError]);

  return (
    <DefaultModalLayout
      closeEvent={() => closeEvent()}
      confirmEvent={() => {
        setAskChangeAlert(true);
      }}
      modalTitle={`${isSelect ? "선택" : "전체"} 상태 변경`}
      modalDesc={
        isSelect
          ? `선택한 고객의 결합 상태를 변경합니다.`
          : `'매칭중'인 전체 고객의 결합 상태를
      '결합중'으로 변경합니다.`
      }
      isMediumModal={true}
      confirmDisabled={
        statusDropdown?.value === "" ||
        (statusDropdown?.value === "5"
          ? reasonDropdown?.value === "5"
            ? reason === ""
            : reasonDropdown?.value === ""
          : false)
      }
      cancelBtnText={"취소"}
      confirmBtnText={"계속"}
    >
      <>
        {/* 상태 */}
        <ModalRow>
          <ModalLabel>상태</ModalLabel>

          <Flex gapSize={10}>
            <Input
              value={nowStatus && isSelect ? uplusState[nowStatus!] : "매칭중"}
              readOnly={true}
            />

            <StatusArrow
              src={require("../../../../assets/dropDown/arrow_drop_down_black_24.png")}
            />

            <DropDown
              boxWidth={160}
              optionList={statusOption}
              dropdownValue={statusDropdown}
              setDropDownValue={setStatusDropdown}
              isDisabled={!isSelect}
            />
          </Flex>
        </ModalRow>

        {/* 변경 대상 */}
        <ModalRow>
          <ModalLabel>변경 대상</ModalLabel>

          <Input
            value={`${
              cntRes?.data?.cnt ??
              selectedKey?.filter((a) => a !== null)?.length ??
              0
            }명`}
          />
        </ModalRow>

        {/* 사유 선택 */}
        {isSelect && statusDropdown?.value === "5" && (
          <ModalRow style={{ alignItems: "flex-start" }}>
            <ModalLabel style={{ width: 89 }}>사유</ModalLabel>

            <div>
              <DropDown
                dropdownValue={reasonDropdown}
                setDropDownValue={setReasonDropdown}
                optionList={reasonOption}
                boxWidth={345}
              />

              {reasonDropdown?.value === "5" && (
                <Input
                  value={reason}
                  onChange={(e) => setReason(e.target.value)}
                  placeholder="직접 입력"
                  style={{ marginTop: 10 }}
                />
              )}
            </div>
          </ModalRow>
        )}

        {(loading || allLoading || cntLoading) && <Loader />}

        {/* 결합 상태 변경 */}
        {askChangeAlert && (
          <UplusMatchingStatusAskModal
            closeEvent={() => setAskChangeAlert(false)}
            nowStatus={
              nowStatus && isSelect ? uplusState[nowStatus!] : "매칭중"
            }
            changeStatus={statusDropdown?.label}
            targetCnt={
              cntRes?.data?.cnt ??
              selectedKey?.filter((a) => a !== null)?.length ??
              0
            }
            confirmEvent={() => {
              if (isSelect) {
                setSelectChange(true);
              } else {
                setAllChange(true);
              }
              setAskChangeAlert(false);
            }}
          />
        )}

        {/* 결합 상태 변경 결과 */}
        {resultModal && (
          <UplusMatchingStatusResultModal
            successCnt={
              allRes?.data?.successcnt ?? response?.data?.successcnt ?? 0
            }
            failCnt={failCnt}
            confirmEvent={() => {
              setResultModal(false);
              closeEvent();
              if (
                confirmEvent &&
                (allRes?.data?.successcnt ?? response?.data?.successcnt ?? 0) >
                  0
              )
                confirmEvent();
            }}
            closeEvent={() => setResultModal(false)}
          />
        )}
      </>
    </DefaultModalLayout>
  );
}

export const StatusArrow = styled.img`
  width: 24px;
  height: 24px;
  transform: rotate(-90deg);
`;
